export default __webpack_public_path__ + "13a9ef245bb1b81d8ef7f63804ff91ea.svg";